<template>
    <div class="recruit">
        <navBar></navBar>
        <div class="s-banner"></div>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <div class="r-content">
                <div class="r-content-item civa-border-bot" v-for="item in recruitItems" :key="item.id" @click="goRecruitDetails(item)">
                    <div class="item-top">
                        <h5 class="title">{{item.job}}</h5>
                        <span class="salary">{{item.salary}}</span>
                    </div>
                    <p class="job">{{item.address}}<span>{{item.years}}</span>{{item.edu}}</p>
                    <p class="date">{{item.updateDate}}</p>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
import navBar from '@/components/navBar';
import { fetchList, listNum } from '@/api/recruit'
export default {
  components: {
    navBar,
  },
  data() {
    return {
      recruitItems: [],
      total: 0,
      loading: false,
      finished: false,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
      },
      listScrollTop: 0,
    }
  },
  activated() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll);// 滚动位置监听
    })
  },
  created() {
    sessionStorage.removeItem('recruitXX');
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('changelistScrollY', this.listScrollTop); // 离开路由时把位置存起来
    window.removeEventListener('scroll', this.handleScroll);
    sessionStorage.setItem('recruitXX', '1');
    next();
  },
  beforeRouteEnter(to, from, next){
    if (from.name === 'recruitDetails') {
      next(vm => {
        const listScrollY = vm.$store.state.listScrollY || 0;
        setTimeout(function () {
          window.scrollTo(0, listScrollY);
        }, 30);
      })
    } else {
      next(vm => {
        if (sessionStorage.getItem('recruitXX')) {
          vm.initialization();
        }
      })
    }
  },
  methods: {
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.listScrollTop = scrollTop;
    },
    initialization(){
      this.recruitItems = [];
      this.listQuery.pageNum = 1;
      this.loading = true;
      this.finished = false;
      if (this.loading){
        this.onLoad();
      }
    },
    // 列表加载
    onLoad() {
      this.getNum()
    },
    // 接口获取招聘信息列表
    fetchData() {
      fetchList(this.listQuery).then(response => {
        const lists = response.result;
        lists.forEach((item) => {
          item.updateDate = item.updateDate.substr(0, 10);
        });
        this.recruitItems = this.recruitItems.concat(lists);
        this.listQuery.pageNum++;
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (this.recruitItems.length >= this.total) {
          this.finished = true;
        }
      })
    },
    // 获取列表总数
    getNum() {
      listNum().then(response => {
        this.total = response.result;
        this.fetchData();
      })
    },
    // 跳转到招聘详情页
    goRecruitDetails(item) {
      this.$router.push({ path: '/recruitDetails', query: { id: item.id }});
    },
  },
}
</script>

<style scoped lang="less">
.recruit{
    .s-banner{
        background: url("https://restaskimg.civaonline.cn/imagesH5/other/recruit-banner.png") no-repeat center center / cover;
    }
    .r-content{
        margin-top: 38px;
        padding: 0 32px 20px 32px;
        .r-content-item{
            width: 100%;
            padding: 30px 0 40px;
            .item-top{
                display: flex;
                justify-content: space-between;
                font-family: SyMedium;
                .title{
                    font-size: 32px;
                    color: #333333;
                    line-height: 45px;
                }
                .salary{
                    color: #FF7500;
                    margin-top: 5px;
                }
            }
            .job{
                font-size: 20px;
                color: #B2B2B2;
                line-height: 28px;
                margin: 23px 0;
                span{
                    margin: 0 30px;
                }
            }
            .date{
                font-size: 24px;
                color: #999999;
                line-height: 33px;
            }
        }
    }
}
</style>
